import styled from "styled-components";

const DESKTOP = "@media (min-width: 768px)";
const BIDS_MAX_WIDTH = "1180px";

/* ─── BidsFilterPage ─────────────────────────────────────────── */

export const PageWrapper = styled.div`
  background: #f0f0f5;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div`
  background: white;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  box-shadow: 0 1px 0 #eee;
  position: sticky;
  top: 0;
  z-index: 10;

  ${DESKTOP} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const TopBarTitle = styled.span`
  flex: 1;
  font-size: 17px;
  font-weight: 700;
  color: #1c1c1c;
`;

export const HelpButton = styled.button`
  background: white;
  border: 1.5px solid #e0e0e0;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s;
  &:hover { background: white; }
`;

export const ListContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${DESKTOP} {
    width: min(calc(100% - 64px), ${BIDS_MAX_WIDTH});
    margin: 0 auto;
    box-sizing: border-box;
    padding: 28px 0 64px;
  }
`;

export const BidCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  transition: transform 0.12s, box-shadow 0.12s;
  &:active { transform: scale(0.98); }
  &:hover { box-shadow: 0 3px 10px rgba(0,0,0,0.1); }
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const IconBox = styled.div`
  width: 48px;
  height: 48px;
  background: #f5f5f5;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Badge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 1;
  background: #ef4f5f;
  color: white;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid white;
`;

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CardTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #1c1c1c;
`;

export const CardSubtitle = styled.span`
  font-size: 13px;
  color: #777;
  font-weight: 400;
`;

export const ChevronRight = styled.div`
  display: flex;
  align-items: center;
`;

/* ─── BidsHelpModal ──────────────────────────────────────────── */

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media (min-width: 600px) {
    align-items: center;
  }
`;

export const Sheet = styled.div`
  background: #f2f2f7;
  width: 100%;
  max-width: 520px;
  border-radius: 20px;
  padding: 24px 20px 28px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const SheetHandle = styled.div`
  display: none;
`;

export const SheetTitle = styled.h2`
  font-size: 22px;
  font-weight: 800;
  color: #1c1c1c;
  margin: 0;
`;

export const SheetClose = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 22px;
  line-height: 1;
`;

export const AudioHint = styled.div`
  background: linear-gradient(to right, #EDFAF1, #FFFFFF);
  border-radius: 12px 12px 0 0;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AudioCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const AudioPlay = styled.button`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: ${p => p.$playing ? "#fcd4d7" : "#fde8ea"};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
`;

export const AudioWaves = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
`;

export const AudioWaveBar = styled.span`
  display: inline-block;
  width: 3px;
  height: ${p => p.height}%;
  background: ${p => p.active ? "#ef4f5f" : "#ddd"};
  border-radius: 2px;
  transition: background 0.2s;
`;

export const AudioDuration = styled.span`
  font-size: 13px;
  color: #777;
  font-weight: 500;
  white-space: nowrap;
`;

export const StepsCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px 18px;
  margin-bottom: 30px;
`;

export const StepRow = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  align-items: flex-start;

  &:not(:last-child) {
    padding-bottom: 24px;
  }

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 52px;
    bottom: 0;
    left: 26px;
    width: 1px;
    background: #d8d8d8;
  }
`;

export const StepBubble = styled.div`
  position: relative;
  width: 52px;
  min-width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1.5px solid #d8d8d8;
  background: linear-gradient(to bottom, #ffffff 0%, #ffffff 58%, #f5f6fa 58%, #f5f6fa 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
  overflow: hidden;

  span:first-child {
    font-size: 18px;
    font-weight: 800;
    color: #1c1c1c;
  }
`;

export const StepBubbleLabel = styled.span`
  font-size: 10px;
  color: #aaa;
  font-weight: 500;
  margin-top: 2px;
`;

export const StepConnector = styled.div`
  width: 1px;
  flex: 1;
  min-height: 28px;
  background: #d8d8d8;
  margin: 3px 0;
`;

export const StepDesc = styled.p`
  font-size: 15px;
  color: #555;
  line-height: 1.55;
  margin: 5px 0 0;
  flex: 1;
`;

export const GotItBtn = styled.button`
  width: 100%;
  background: #ef4f5f;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #d63d4b; }
  &:active { background: #c23040; }
`;

export const Wrapper = styled.div`
  background: #f0f0f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const BidsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;

  ${DESKTOP} {
    width: min(calc(100% - 64px), ${BIDS_MAX_WIDTH});
    margin: 0 auto;
    box-sizing: border-box;
    padding: 28px 0 64px;
  }
`;

export const BidItem = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  padding: 14px 12px;
  cursor: pointer;
  gap: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  transition: background 0.15s;
  &:active { background: #fafafa; }
`;

export const BidIcon = styled.div`
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const BidContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BidTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #1c1c1c;
`;

export const BidSubtitle = styled.span`
  font-size: 12px;
  color: #888;
`;

export const BidAmount = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #ef4f5f;
  margin-top: 2px;
`;

export const RightArrow = styled.span`
  font-size: 22px;
  color: #bbb;
  line-height: 1;
`;

/* ─── BidsList ─────────────────────────────────────────────────── */

export const ListPageWrapper = styled.div`
  background: #f0f0f5;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const ListTopBar = styled.div`
  background: white;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  box-shadow: 0 1px 0 #eee;
  position: sticky;
  top: 0;
  z-index: 10;

  ${DESKTOP} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const ListTopBarLeft = styled.div`
  flex: 1;
`;

export const ListTopBarTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #1c1c1c;
  line-height: 1.2;
`;

export const ListTopBarSubtitle = styled.div`
  font-size: 12px;
  color: #888;
  font-weight: 400;
`;

export const IconBtn = styled.button`
  background: white;
  border: 1.5px solid #e0e0e0;
  width: 36px;
  height: 36px;
  padding: 0;
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover { background: #f5f5f5; }
`;

export const CardShareBtn = styled.button`
  background: white;
  border: 1.5px solid #ececec;
  width: 40px;
  height: 40px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover { background: #f0f0f2; }
`;

export const SearchBarWrapper = styled.div`
  background: white;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;

  ${DESKTOP} {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    box-sizing: border-box;
  }
`;

export const SearchInput = styled.div`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 10px 14px;
  gap: 8px;
  color: #aaa;
  font-size: 14px;
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border-bottom: 1px solid #f0f0f0;

  ${DESKTOP} {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    box-sizing: border-box;
  }
`;

export const FilterChip = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1.5px solid ${p => p.$active ? '#ef4f5f' : '#e0e0e0'};
  background: ${p => p.$active ? '#fff0f1' : 'white'};
  color: ${p => p.$active ? '#ef4f5f' : '#444'};
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

export const BidCardsWrapper = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${DESKTOP} {
    width: min(calc(100% - 64px), ${BIDS_MAX_WIDTH});
    margin: 0 auto;
    box-sizing: border-box;
    padding: 28px 0 64px;
  }
`;

/* ─── BidCard ────────────────────────────────────────────────────── */

export const BidCardContainer = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.12s;
  position: relative;
  &:active { transform: scale(0.99); }
`;

export const BidCardTop = styled.div`
  padding: 16px 16px 12px;
`;

export const BidCardTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
`;

export const BidCardTitleBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BidCardTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.3;
`;

export const BidCardId = styled.div`
  font-size: 13px;
  color: #999;
  font-weight: 500;
  margin-top: 4px;
`;

export const BidMetaRow = styled.div`
  display: flex;
  border: 1.5px dashed #d0d0d0;
  border-radius: 14px;
  margin-bottom: 14px;
  overflow: hidden;
`;

export const BidMetaBox = styled.div`
  flex: 1;
  padding: 12px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const BidMetaLabel = styled.div`
  font-size: 13px;
  color: #1c1c1c;
  font-weight: 700;
  text-align: center;
  line-height: 1.3;
`;

export const BidMetaIcon = styled.div`
  color: #888;
`;

export const ProductThumbsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: nowrap;
  overflow: hidden;

  ${DESKTOP} {
    justify-content: flex-start;
  }
`;

export const ProductThumb = styled.div`
  width: calc((100% - 32px) / 5);
  aspect-ratio: 1;
  border-radius: 12px;
  background: white;
  border: 1.5px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  overflow: hidden;
  flex: 0 0 calc((100% - 32px) / 5);

  ${DESKTOP} {
    width: 56px;
    height: 56px;
    aspect-ratio: auto;
    flex: 0 0 56px;
    font-size: 24px;
  }
`;

export const ProductThumbMore = styled.div`
  width: calc((100% - 32px) / 5);
  aspect-ratio: 1;
  border-radius: 12px;
  background: #f2f2f2;
  border: 1.5px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #555;
  flex: 0 0 calc((100% - 32px) / 5);
  text-align: center;
  padding: 4px;

  ${DESKTOP} {
    width: 56px;
    height: 56px;
    aspect-ratio: auto;
    flex: 0 0 56px;
    font-size: 11px;
  }
`;

export const BidCardFooter = styled.div`
  background: ${p => {
    if (p.$status === 'live')          return 'linear-gradient(to right, #FFEDEF, #FFFFFF)';
    if (p.$status === 'submitted')     return 'linear-gradient(to right, #EAFBF0, #FFFFFF)';
    if (p.$status === 'awarded')       return 'linear-gradient(to right, #EFF3FF, #FFFFFF)';
    if (p.$status === 'completed')     return 'linear-gradient(to right, #F2F3F5, #FFFFFF)';
    if (p.$status === 'not_awarded')   return 'linear-gradient(to right, #FFF0F1, #FFFFFF)';
    if (p.$status === 'upcoming')      return 'linear-gradient(to right, #F4F4F7, #FFFFFF)';
    if (p.$status === 'no_submission') return 'linear-gradient(to right, #F5F5F5, #FFFFFF)';
    return 'linear-gradient(to right, #FAFAFA, #FFFFFF)';
  }};
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BidStatusLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  color: ${p => {
    if (p.$status === 'live') return '#ef4f5f';
    if (p.$status === 'upcoming') return '#888';
    if (p.$status === 'awarded') return '#4c6ef5';
    if (p.$status === 'completed') return '#666';
    if (p.$status === 'submitted') return '#2da44e';
    if (p.$status === 'not_awarded') return '#ef4f5f';
    if (p.$status === 'no_submission') return '#999';
    return '#666';
  }};

  svg {
    display: block;
    flex-shrink: 0;
  }
`;

export const BidStatusDot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${p => {
    if (p.$status === 'live') return '#ef4f5f';
    if (p.$status === 'upcoming') return '#888';
    if (p.$status === 'awarded') return '#4c6ef5';
    if (p.$status === 'completed') return '#999';
    if (p.$status === 'submitted') return '#2da44e';
    if (p.$status === 'not_awarded') return '#ef4f5f';
    return '#999';
  }};
`;

export const BidCardTimeWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;
  font-size: 13px;

  > span {
    font-size: 13px;
  }
`;

export const BidCardTimePrefix = styled.span`
  && {
    font-size: 13px;
  }
  color: #888;
  font-weight: 400;
  margin-right: 3px;
`;

export const BidCardTimeSuffix = styled.span`
  && {
    font-size: 13px;
  }
  font-weight: ${p => p.$status === 'live' ? '700' : '500'};
  color: ${p => p.$status === 'live' ? '#ef4f5f' : '#888'};
`;

/* ─── BidDetails ────────────────────────────────────────────────── */

export const DetailPageWrapper = styled.div`
  background: #f0f0f5;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
`;

export const DetailTopBar = styled.div`
  background: white;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  box-shadow: 0 1px 0 #eee;
  position: sticky;
  top: 0;
  z-index: 10;

  ${DESKTOP} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const DetailTopBarInfo = styled.div`
  flex: 1;
`;

export const DetailTopBarTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #1c1c1c;
`;

export const DetailTopBarSub = styled.div`
  font-size: 12px;
  color: #888;
`;

export const DetailContent = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${DESKTOP} {
    width: min(calc(100% - 64px), ${BIDS_MAX_WIDTH});
    margin: 0 auto;
    box-sizing: border-box;
    padding: 28px 0 64px;
  }
`;

export const DetailHeaderCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
`;

export const DetailCardTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eef0f5;
  margin-bottom: 14px;
  margin-right: -16px;
`;

export const DetailCardTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #1a1a2e;
  flex: 1;
  line-height: 1.3;
`;

export const DetailHeaderBody = styled.div`
  padding: 0;
`;

export const DetailStatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
`;

export const DetailStatBox = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const DetailStatSubLabel = styled.div`
  color: #aaa;
  font-size: 11px;
  font-weight: 400;
`;

export const DetailDashedDivider = styled.div`
  border-top: 1.5px dashed #dfe3ed;
  margin: 10px 0;
`;

export const DetailAddressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 10px 0;
  color: #555;
  font-size: 13px;
  line-height: 1.4;

  span {
    font-size: 13px;
  }
`;

export const DetailAddressIconBox = styled.div`
  width: 44px;
  height: 44px;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 44px;
    height: 44px;
  }
`;

export const StatusPill = styled.div`
  background: ${p => {
    if (p.$status === 'live') return '#079a4a';
    if (p.$status === 'upcoming') return '#888';
    if (p.$status === 'awarded') return '#4c6ef5';
    if (p.$status === 'completed') return '#666';
    if (p.$status === 'submitted') return '#2da44e';
    if (p.$status === 'not_awarded') return '#ef4f5f';
    if (p.$status === 'no_submission') return '#999';
    return '#666';
  }};
  color: white;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 8px 0 0 8px;
  text-transform: capitalize;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const AddressRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 10px 0;
  font-size: 13px;
  color: #555;
`;

export const BidTimingText = styled.div`
  font-size: 13px;
  color: #888;
  font-weight: 400;
  text-align: center;
  padding: 4px 0 2px;

  span {
    font-size: 13px;
    color: #125C31;
    font-weight: 700;
  }
`;

export const SectionCard = styled.div`
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);
`;

export const SectionDividerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #aaa;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #d9dde6;
  }
`;

export const ProductCountTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1c1c1c;
  padding: 14px 16px 8px;
`;

export const ProductListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
`;

export const ProductImg = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 14px;
  background: #fdf3f3;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
  overflow: hidden;
`;

export const ProductInfo = styled.div`
  flex: 1;
`;

export const ProductName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #1c1c1c;
  line-height: 1.35;
`;

export const ProductMeta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 4px;
  font-weight: 400;
`;

export const LiveProductActionCard = styled(SectionCard)`
  ${DESKTOP} {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 16px;
  }
`;

export const LiveProductActionInfo = styled(ProductListItem)`
  border-bottom: none;
  padding-bottom: 16px;

  ${DESKTOP} {
    flex: 1;
    min-width: 0;
    padding: 0;
  }
`;

export const LiveProductActionDivider = styled.div`
  border-top: 1.5px dashed #e8e8e8;
  margin: 0 14px;

  ${DESKTOP} {
    display: none;
  }
`;

export const LiveProductActionButtonWrap = styled.div`
  padding: 12px;

  ${DESKTOP} {
    flex: 0 0 auto;
    padding: 0;
  }
`;

export const LiveProductActionButton = styled.button`
  width: 100%;
  background: #fff0f1;
  border: none;
  border-radius: 14px;
  padding: 14px;
  font-size: 14px;
  font-weight: 500;
  color: #EF4F5F;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  ${DESKTOP} {
    width: auto;
    min-width: 240px;
    padding: 14px 24px;
  }
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  border-bottom: ${p => p.$open ? '1px solid #f0f0f0' : 'none'};
`;

export const AccordionTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #1c1c1c;
`;

export const DidNotBidSection = styled.div`
  padding: 12px 16px 8px;
`;

export const DidNotBidLabel = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 10px;
`;

export const SeeDetailsLink = styled.div`
  text-align: center;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #ef4f5f;
  cursor: pointer;
`;

export const CtaButton = styled.button`
  width: 100%;
  height: 40px;
  background: #ef4f5f;
  color: white;
  border: none;
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 8px;
  margin-top: 4px;
  transition: background 0.15s;
  &:hover { background: #d63d4b; }
`;

/* ─── FAQ ──────────────────────────────────────────────────────── */

export const FAQWrapper = styled.div`
  background: #f0f0f5;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
`;

export const FAQTopBar = styled.div`
  background: white;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  box-shadow: 0 1px 0 #eee;
  position: sticky;
  top: 0;
  z-index: 10;

  ${DESKTOP} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const FAQTopBarTitle = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #1c1c1c;
`;

export const FAQList = styled.div`
  margin: 14px 16px;
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);

  ${DESKTOP} {
    width: min(calc(100% - 64px), ${BIDS_MAX_WIDTH});
    margin: 28px auto 64px;
    box-sizing: border-box;
  }
`;

export const FAQItem = styled.div`
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;

export const FAQQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #1c1c1c;
`;

export const FAQAnswer = styled.div`
  padding: 0 16px 16px;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
`;

export const FAQChevron = styled.div`
  color: #ccc;
  transition: transform 0.2s;
  transform: ${p => p.$open ? 'rotate(180deg)' : 'rotate(0deg)'};
  flex-shrink: 0;
`;
